// Mock data for EASY2HOME products showcase website
export const products = [
  {
    id: 1,
    name: "Magnifying Shaving Makeup Mirror",
    shortName: "Wall Mount Mirror",
    price: 1197,
    originalPrice: 2100,
    discount: 43,
    rating: 4.7,
    reviews: 1425,
    image: "https://m.media-amazon.com/images/I/51nvlgOf10S._SX522_.jpg",
    gallery: [
      "https://m.media-amazon.com/images/I/51nvlgOf10S._SX522_.jpg",
      "https://m.media-amazon.com/images/I/418BmjebMOS._SS100_.jpg",
      "https://m.media-amazon.com/images/I/41ZlsWDbNCL._SS100_.jpg"
    ],
    category: "Bathroom Mirrors",
    inStock: true,
    amazonLink: "https://www.amazon.in/EASY2HOME-Magnifying-Shaving-Stainless-Bathroom/dp/B08XKBYRPN",
    features: [
      "Powerful magnification on one side and normal on other",
      "Stainless steel construction",
      "Wall mount design",
      "8 inch diameter",
      "Chrome finish",
      "360° rotating capability"
    ],
    specifications: {
      "Brand": "EASY2HOME",
      "Material": "Stainless Steel",
      "Mounting Type": "Wall Mount",
      "Size": "8 Inch (ROD TYPE)",
      "Color": "Silver",
      "Frame Material": "Stainless Steel",
      "Shape": "Round",
      "Finish Type": "CHROME",
      "Special Feature": "2-Sided"
    },
    description: "EASY2HOME brings you a unique magnifying shaving mirror with powerful magnification on one side and normal mirror on the other. The stainless steel construction ensures durability while the elegant design complements any bathroom décor."
  },
  {
    id: 2,
    name: "Hand Dryer Automatic",
    shortName: "Electric Hand Dryer",
    price: 2188,
    originalPrice: 4999,
    discount: 56,
    rating: 4.6,
    reviews: 426,
    image: "https://m.media-amazon.com/images/I/3179iuPO67L._SX466_.jpg",
    gallery: [
      "https://m.media-amazon.com/images/I/3179iuPO67L._SX466_.jpg",
      "https://m.media-amazon.com/images/I/41YEcj2u4XL._SS100_.jpg",
      "https://m.media-amazon.com/images/I/41oHbSenvxL._SS100_.jpg"
    ],
    category: "Bathroom Accessories",
    inStock: true,
    amazonLink: "https://www.amazon.in/EASY2HOME-Household-Commercial-Electric-Automatic/dp/B08TVV1BK3",
    features: [
      "Fast drying - impressive wind speed",
      "Automated ON/OFF sensor",
      "Low noise pollution",
      "80% less energy than conventional dryers",
      "Easy wall mounting",
      "Modern stylish design"
    ],
    specifications: {
      "Brand": "EASY2HOME",
      "Power": "1800 Watt",
      "Material": "ABS Plastic",
      "Color": "White",
      "Form Factor": "Front Load",
      "Mounting Type": "Wall Mount",
      "Voltage": "220-240V",
      "Made in": "India"
    },
    description: "EASY2HOME automatic hand dryer with 1800W power provides fast hand drying in seconds. The touchless sensor operation ensures hygiene while saving 80% energy compared to conventional hand dryers. Perfect for hotels, offices, homes, and spas."
  },
  {
    id: 3,
    name: "Makeup Mirror Double Sided",
    shortName: "Tabletop Vanity Mirror",
    price: 699,
    originalPrice: 1500,
    discount: 53,
    rating: 4.7,
    reviews: 26,
    image: "https://m.media-amazon.com/images/I/41Yyfb1R0EL._SY355_.jpg",
    gallery: [
      "https://m.media-amazon.com/images/I/41Yyfb1R0EL._SY355_.jpg",
      "https://m.media-amazon.com/images/I/31R+BsVhr4L._SS100_.jpg",
      "https://m.media-amazon.com/images/I/31GzpWa7vtL._SS100_.jpg"
    ],
    category: "Vanity Mirrors",
    inStock: true,
    amazonLink: "https://www.amazon.in/gp/product/B0D9TMZRQN",
    features: [
      "One side magnifying, other side normal",
      "Chrome finish stainless steel",
      "Super stable tabletop stand",
      "Portable and lightweight",
      "360° rotation",
      "Perfect for grooming and makeup"
    ],
    specifications: {
      "Brand": "EASY2HOME",
      "Material": "Stainless Steel",
      "Mounting Type": "Tabletop Mount",
      "Size": "6 inch diameter",
      "Color": "Silver",
      "Frame Material": "Stainless Steel",
      "Shape": "Round",
      "Finish Type": "Chrome Plated",
      "Special Feature": "Lightweight, Magnifying, Portable"
    },
    description: "Elegant double-sided makeup mirror with magnifying feature. Perfect for daily makeup routine, grooming, and wearing lenses. The sturdy stainless steel construction with chrome finish ensures long-lasting use."
  },
  {
    id: 4,
    name: "Bathroom Cabinet with Mirror",
    shortName: "Storage Cabinet",
    price: 999,
    originalPrice: 2000,
    discount: 50,
    rating: 4.6,
    reviews: 2249,
    image: "https://m.media-amazon.com/images/I/51+jHsg0m1L._SX522_.jpg",
    gallery: [
      "https://m.media-amazon.com/images/I/51+jHsg0m1L._SX522_.jpg",
      "https://m.media-amazon.com/images/I/410tMuv5XDL._SS100_.jpg",
      "https://m.media-amazon.com/images/I/418rN8zoTOL._SS100_.jpg"
    ],
    category: "Bathroom Storage",
    inStock: true,
    amazonLink: "https://www.amazon.in/EASY2HOME-Bathroom-Cabinet-Plastic-Organiser/dp/B093QDTXW8",
    features: [
      "High grade PPCP plastic - strong and durable",
      "Wall mounted design",
      "Includes mirror",
      "Multiple storage compartments",
      "Easy to install",
      "Rich premium look"
    ],
    specifications: {
      "Brand": "EASY2HOME",
      "Material": "Plastic (PPCP)",
      "Color": "Star White",
      "Mounting Type": "Wall Mount",
      "Size": "21 x 12 inches",
      "Dimensions": "6D x 31W x 45H Centimeters",
      "Door Style": "Pivot Door Type",
      "Special Feature": "Heavy Duty",
      "Room Type": "Bathroom, Kitchen, Laundry Room"
    },
    description: "Premium bathroom cabinet with mirror made from high-grade plastic. Perfect for organizing bathroom essentials with a rich, elegant look. Wall-mounted design saves space and adds functionality to your bathroom, kitchen, or office."
  }
];

export const categories = [
  { id: 1, name: "All Products", slug: "all" },
  { id: 2, name: "Bathroom Mirrors", slug: "mirrors" },
  { id: 3, name: "Bathroom Accessories", slug: "accessories" },
  { id: 4, name: "Storage Solutions", slug: "storage" }
];

export const companyInfo = {
  name: "EASY2HOME",
  tagline: "Making Home Beautiful & Functional",
  about: "EASY2HOME brings you a unique selection of bathroom gadgets and accessories to make your everyday life simple and easy. Our extensive range of bathroom accessories and related products helps conserve resources that save your time, effort & money. Bring home these innovative gadgets to enjoy the luxury of 'good living' & designing your lifestyle.",
  email: "easy2homeaz@gmail.com",
  phone: "+91 9310411196",
  whatsapp: "+91 9310411196",
  address: "New Delhi, India",
  socialMedia: {
    facebook: "#",
    instagram: "#",
    twitter: "#"
  }
};

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    rating: 5,
    comment: "Excellent quality products! The bathroom cabinet is sturdy and looks premium. Highly recommended!",
    product: "Bathroom Cabinet with Mirror"
  },
  {
    id: 2,
    name: "Rajesh Kumar",
    rating: 5,
    comment: "The hand dryer works perfectly. Very hygienic and saves so much on paper towels. Great purchase!",
    product: "Hand Dryer Automatic"
  },
  {
    id: 3,
    name: "Anita Desai",
    rating: 4,
    comment: "Beautiful makeup mirror with excellent magnification. Perfect for my daily routine.",
    product: "Makeup Mirror Double Sided"
  }
];

export const faqs = [
  {
    question: "Do you provide installation services?",
    answer: "Our products are designed for easy self-installation with all necessary hardware included. However, we recommend professional installation for wall-mounted items."
  },
  {
    question: "What is your return policy?",
    answer: "We offer a 10-day replacement policy for damaged, defective, or wrong items. The product must be in original condition with all packaging and accessories."
  },
  {
    question: "Do you ship across India?",
    answer: "Yes, we ship to all locations across India. Free delivery is available on most products through Amazon."
  },
  {
    question: "How can I track my order?",
    answer: "Once your order is shipped from Amazon, you will receive a tracking number via email and SMS to track your delivery."
  }
];
